export const MEDICINE_REQUEST_DETAIL_REQUESTED = 'MEDICINE_REQUEST_DETAIL_REQUESTED';
export const MEDICINE_REQUEST_DETAIL_SUCCEED = 'MEDICINE_REQUEST_DETAIL_SUCCEED';
export const MEDICINE_REQUEST_DETAIL_FAILED = 'MEDICINE_REQUEST_DETAIL_FAILED';

export const MEDICINE_REQUEST_APPROVE_REQUESTED = 'MEDICINE_REQUEST_APPROVE_REQUESTED';
export const MEDICINE_REQUEST_APPROVE_SUCCEED = 'MEDICINE_REQUEST_APPROVE_SUCCEED';
export const MEDICINE_REQUEST_APPROVE_FAILED = 'MEDICINE_REQUEST_APPROVE_FAILED';
